export default class ThumbGenerator {
    /**
     * @param {object} bounds - images will be resized to fill the bounds as
     *                          closely as possible, while still filling it
     *                          entirely
     * @param {number} bounds.width
     * @param {number} bounds.height
     * @param {boolean} [clipBounds=true] - clip pixels lying outside the bounds
     */
    constructor(bounds, clipBounds = true) {
        this.bounds = bounds;
        this.clipBounds = clipBounds;
        this.canvas = document.createElement('canvas');
    }

    /**
     * @param {string|HTMLImageElement} urlOrImg
     * @param {object} [options]
     * @param {boolean} [options.returnImage]
     * @param {boolean} [options.returnUrl]
     * @returns {Blob|HTMLImageElement|string} - blob by default
     */
    async genThumb(urlOrImg, options) {

        function getImgFromUrl(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    if (img.width + img.height === 0) {
                        reject();
                    } else {
                        resolve(img);
                    }
                };
                img.onerror = reject;
                img.src = url;
            });
        }

        // Get the src image from param
        const srcImg = await (async () => {
            if (urlOrImg instanceof HTMLImageElement) {
                return urlOrImg;
            } else {
                return await getImgFromUrl(urlOrImg);
            }
        })();

        // Calculate the thumbnail dimensions
        const bounds = this.bounds;
        let x, y, w, h;
        x = y = 0;
        w = bounds.width;
        h = bounds.height;

        const srcAspect = srcImg.width / srcImg.height;
        const bndAspect = bounds.width / bounds.height;
        if (srcAspect > bndAspect) {
            w = srcAspect * h;
            x = -(w - bounds.width) / 2;
        } else if (srcAspect < bndAspect) {
            h = w / srcAspect;
            y = -(h - bounds.height) / 2;
        }

        // Resize the canvas to preserve or clip thumb data outside bounds
        if (this.clipBounds) {
            this.canvas.width = bounds.width;
            this.canvas.height = bounds.height;
        } else {
            this.canvas.width = w;
            this.canvas.height = h;
            x = 0;
            y = 0;
        }

        // Resize the src image using the canvas
        const ctx = this.canvas.getContext('2d');
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        ctx.drawImage(srcImg, x, y, w, h);

        // Extract the thumbnail from the canvas
        if (options && options.returnUrl) {
            return this.canvas.toDataURL('image/png');
        }
        if (options && options.returnImage) {
            return await getImgFromUrl(this.canvas.toDataURL());
        }
        return await new Promise((resolve, reject) => {
            this.canvas.toBlob(resolve);
        });
    }
}



// WEBPACK FOOTER //
// ./src/packages/thumb-generator/index.js